module.exports = __webpack_public_path__ + "static/media/function_apps.294c137a.svg";